import React from "react";
import heroVideoDesktop from "../../../assets/girl.mp4";
import heroVideoMobile from "../../../assets/Mobile1.mp4"; 
export default function HeroImage() {
  return (
    <>
      {/* Desktop Video */}
      <video
        src={heroVideoDesktop}
        autoPlay
        loop
        muted
        playsInline
        className="hidden md:block w-full h-full object-cover absolute top-0 left-0"
      />

      {/* Mobile Video */}
      <video
        src={heroVideoMobile}
        autoPlay
        loop
        muted
        playsInline
        className="block md:hidden w-full h-full object-cover absolute top-0 left-0"
      />
    </>
  );
}
